<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">Postanowienia dotyczące umowy</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-4 mb-3">
                <div class="col-12 col-md-6">
                    <div class="d-flex flex-column gap-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="celPrywatny" v-model="form.privatePurpose" />
                            <label class="form-check-label" for="celPrywatny">Cel prywatny</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="celGospodarczy" v-model="form.businessPurpose" />
                            <label class="form-check-label" for="celGospodarczy">Cel gospodarczy</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="podatekPCC" v-model="form.pccTax" />
                            <label class="form-check-label" for="podatekPCC">Podatek od czynności cywilnoprawnych</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="podatekVAT" v-model="form.vatTax" />
                            <label class="form-check-label" for="podatekVAT">Podatek od towarów i usług</label>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-check mb-3">
                        <input class="form-check-input" type="checkbox" id="cenaUiszczona" v-model="form.pricePaidOnSigning" />
                        <label class="form-check-label" for="cenaUiszczona">Cena uiszczona przy zawarciu umowy</label>
                    </div>
                    <div class="mb-3">
                        <label class="form-label small">W terminie (dni)</label>
                        <input type="number" class="form-control" v-model="form.paymentTermDays" min="0" />
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label text-muted small">Pozostałe postanowienia</label>
                <textarea class="form-control font-monospace" rows="8" v-model="form.provisions" maxlength="6000"></textarea>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'

const props = defineProps({ modelValue: { type: Object, required: true } })
const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; user-select: none; }
</style>